function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

// Check if a point is inside a polygon using ray casting algorithm
function isPointInPolygon(point, polygon) {
  let x = point[0], y = point[1];
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    let xi = polygon[i][0], yi = polygon[i][1];
    let xj = polygon[j][0], yj = polygon[j][1];

    let intersect = ((yi > y) != (yj > y))
        && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    if (intersect) inside = !inside;
  }

  return inside;
}

// Generate random spots on the dog (only inside head contour)
export function generateSpots(headContour, numSpots = 5) {
  let spots = [];
  let attempts = 0;
  let maxAttempts = numSpots * 20; // Prevent infinite loop

  while (spots.length < numSpots && attempts < maxAttempts) {
    attempts++;

    // Calculate bounding box from contour
    let minX = Math.min(...headContour.map(p => p[0]));
    let maxX = Math.max(...headContour.map(p => p[0]));
    let minY = Math.min(...headContour.map(p => p[1]));
    let maxY = Math.max(...headContour.map(p => p[1]));

    // Generate random point within bounding box, but biased towards center
    let x = randomFromInterval(minX * 0.5, maxX * 0.5);
    let y = randomFromInterval(minY * 0.5, maxY * 0.3);
    let radius = randomFromInterval(6, 12);

    // Check if point is inside the head contour
    if (isPointInPolygon([x, y], headContour)) {
      spots.push({ x, y, radius });
    }
  }

  return spots;
}

// Generate fur lines/texture
export function generateFurLines(headContour, numLines = 30) {
  let furLines = [];

  for (let i = 0; i < numLines; i++) {
    let startIndex = Math.floor(randomFromInterval(0, headContour.length - 1));
    let startPoint = headContour[startIndex];

    let lineLength = randomFromInterval(10, 25);
    let angle = randomFromInterval(0, Math.PI * 2);

    let endPoint = [
      startPoint[0] + Math.cos(angle) * lineLength,
      startPoint[1] + Math.sin(angle) * lineLength
    ];

    furLines.push([startPoint, endPoint]);
  }

  return furLines;
}

// Generate patches (larger irregular spots, only inside head contour)
export function generatePatches(headContour, numPatches = 3) {
  let patches = [];
  let attempts = 0;
  let maxAttempts = numPatches * 20;

  while (patches.length < numPatches && attempts < maxAttempts) {
    attempts++;

    // Calculate bounding box from contour
    let minX = Math.min(...headContour.map(p => p[0]));
    let maxX = Math.max(...headContour.map(p => p[0]));
    let minY = Math.min(...headContour.map(p => p[1]));
    let maxY = Math.max(...headContour.map(p => p[1]));

    // Generate random center point, biased towards upper/center
    let centerX = randomFromInterval(minX * 0.4, maxX * 0.4);
    let centerY = randomFromInterval(minY * 0.5, maxY * 0.2);

    // Check if center is inside head
    if (!isPointInPolygon([centerX, centerY], headContour)) {
      continue;
    }

    let size = randomFromInterval(10, 16);
    let patchPoints = [];
    let numPoints = 8;
    let allPointsInside = true;

    for (let j = 0; j < numPoints; j++) {
      let angle = (j / numPoints) * Math.PI * 2;
      let radius = size + randomFromInterval(-size * 0.3, size * 0.3);
      let x = centerX + Math.cos(angle) * radius;
      let y = centerY + Math.sin(angle) * radius;

      // Check if patch point is inside head
      if (!isPointInPolygon([x, y], headContour)) {
        allPointsInside = false;
        break;
      }

      patchPoints.push([x, y]);
    }

    // Only add patch if all points are inside
    if (allPointsInside && patchPoints.length === numPoints) {
      patchPoints.push(patchPoints[0]);
      patches.push(patchPoints);
    }
  }

  return patches;
}
